// src/Reports.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getStorage } from '../Components/Storage.js';
import '../CSS/Umbrella.css';
import '../CSS/ReportsGrid.css';
import UmbrellaReportsGrid from './UmbrellaReportsGrid.js';
import useIsMobile from '../Components/UseIsMobile.js';

const YourComponent = () => {
  const { companyName } = useParams();
  const [clients, setClients] = useState([]);
  const [cansee, setCanSee] = useState(false);

  const username = getStorage('username');
  const isMobile = useIsMobile();

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSector, setSelectedSector] = useState('');
  const [groupResponsible, setGroupResponsible] = useState('');
  const [targetedEntity, setTargetedEntity] = useState('');
  const [selectedDropdownFilter, setSelectedDropdownFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedIndustryFilter, setSelectedIndustryFilter] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');

  useEffect(() => {
    fetch('/api/hello')
      .then(r => r.json())
      .then(data => setClients(data.clients || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!username || clients.length === 0) return;

    const match = clients.find(c =>
      c.fields.Email?.toLowerCase() === username.toLowerCase() &&
      c.fields.SpecCompany &&
      c.fields.Company === companyName
    );

    setCanSee(!!match);
  }, [clients, username, companyName]);

  const handleClear = () => {
    setSearchTerm('');
    setSelectedSector('');
    setGroupResponsible('');
    setTargetedEntity('');
    setSelectedDropdownFilter('');
    setStartDate('');
    setEndDate('');
    setSelectedIndustryFilter('');
    setSelectedRegion('');
  };

  if (!cansee) {
    return (
      <div className="umbrella-denied">
        <p>You don't have access to view this content.</p>
      </div>
    );
  }

  const FilterSidebar = () => (
    <>
      <h3 className="filters-title">Filters</h3>

      <div className="filter-group">
        <label>Sector</label>
        <select value={selectedSector} onChange={(e) => setSelectedSector(e.target.value)}>
          <option value="">All Sectors</option>
          <option value="Animal Rights">Animal Rights</option>
          <option value="Energy Sector">Energy Sector</option>
          <option value="Pharmaceuticals">Pharmaceuticals</option>
          <option value="Critical Insights">Critical Insights</option>
        </select>
      </div>

      <div className="filter-group">
        <label>Region</label>
        <select value={selectedRegion} onChange={(e) => setSelectedRegion(e.target.value)}>
          <option value="">All Regions</option>
          <option value="North America">North America</option>
          <option value="Latin America">Latin America</option>
          <option value="Western Europe">Western Europe</option>
          <option value="Eastern Europe">Eastern Europe</option>
          <option value="Middle East">Middle East</option>
          <option value="Asia">Asia</option>
          <option value="Africa">Africa</option>
          <option value="Oceania">Oceania</option>
        </select>
      </div>

      <div className="filter-group">
        <label>Search Title</label>
        <input
          type="text"
          placeholder="Search by title"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label>Group Responsible</label>
        <input
          type="text"
          placeholder="Search by group"
          value={groupResponsible}
          onChange={(e) => setGroupResponsible(e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label>Targeted Entity</label>
        <input
          type="text"
          placeholder="Search entity"
          value={targetedEntity}
          onChange={(e) => setTargetedEntity(e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label>Type of Report</label>
        <select value={selectedDropdownFilter} onChange={(e) => setSelectedDropdownFilter(e.target.value)}>
          <option value="">All Types</option>
          <option value="protest after-action">Protest After-Action</option>
          <option value="direct action">Direct Action</option>
          <option value="general intel">General Intel</option>
          <option value="infiltration">Infiltration</option>
        </select>
      </div>

      <div className="filter-group">
        <label>Targeted Industry</label>
        <select value={selectedIndustryFilter} onChange={(e) => setSelectedIndustryFilter(e.target.value)}>
          <option value="">All Industries</option>
          <option value="Fur and Leather">Fur and Leather</option>
          <option value="Hunting">Hunting</option>
          <option value="Research – CRO">Research – CRO</option>
          <option value="Research – Academic">Research – Academic</option>
          <option value="Research – Breeder">Research – Breeder</option>
          <option value="Research – General">Research – General</option>
          <option value="Research – Pharmaceuticals">Research – Pharmaceuticals</option>
          <option value="Research – Transportation">Research – Transportation</option>
          <option value="Research – Government">Research – Government</option>
          <option value="Research – Cosmetics">Research – Cosmetics</option>
          <option value="Research – Other">Research – Other</option>
          <option value="Agriculture – General">Agriculture – General</option>
          <option value="Agriculture – Transportation">Agriculture – Transportation</option>
          <option value="Agriculture – Government">Agriculture – Government</option>
          <option value="Agriculture – Food Services">Agriculture – Food Services</option>
          <option value="Agriculture – Farms">Agriculture – Farms</option>
          <option value="Agriculture – Processing">Agriculture – Processing</option>
          <option value="Entertainment – Government">Entertainment – Government</option>
          <option value="Entertainment – Sports">Entertainment – Sports</option>
          <option value="Entertainment – Zoo/Park">Entertainment – Zoo/Park</option>
          <option value="Pet Industry">Pet Industry</option>
          <option value="Coal">ES - Coal</option>
          <option value="Logging">ES - Logging</option>
          <option value="Academic">ES - Academic</option>
          <option value="Financing">ES - Financing</option>
          <option value="Government">ES - Government</option>
          <option value="Fossil Fuels">ES - Fossil Fuels</option>
          <option value="Nuclear">ES - Nuclear</option>
          <option value="Renewables">ES - Renewables</option>
          <option value="Anti-Vaccine">Pharma - Anti-Vaccine</option>
          <option value="Access to Medicine">Pharma - Access to Medicine</option>
          <option value="GMO">Pharma - GMO</option>
        </select>
      </div>

      <div className="filter-group">
        <label>Start Date</label>
        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
      </div>

      <div className="filter-group">
        <label>End Date</label>
        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </div>

      <button onClick={handleClear} className="clear-button full-width">
        Clear Filters
      </button>
    </>
  );

  return (
    <div className="umbrella-page">
      <div className="umbrella-layout">
        {!isMobile && (
          <aside className="umbrella-sidebar">
            <FilterSidebar />
          </aside>
        )}

        <main className="umbrella-content">
          <div className="umbrella-head">
            <h1>Reports for {companyName}</h1>
          </div>

          {isMobile && (
            <div className="mobile-filters umbrella-mobile-filters">
              <FilterSidebar />
            </div>
          )}

          <UmbrellaReportsGrid
            searchTerm={searchTerm}
            selectedSector={selectedSector}
            groupResponsible={groupResponsible}
            targetedEntity={targetedEntity}
            selectedDropdownFilter={selectedDropdownFilter}
            compName={companyName}
            startDate={startDate}
            endDate={endDate}
            selectedIndustryFilter={selectedIndustryFilter}
            selectedRegion={selectedRegion}
          />
        </main>
      </div>
    </div>
  );
};

export default YourComponent;